export const SET_SELECTED_OPERATOR = "SET_SELECTED_OPERATOR";
